<template>
  <div
    role="status"
    aria-live="polite"
    :class="[
      'inline-flex items-center gap-2 px-6 py-2.5 rounded-full shadow-lg text-sm font-semibold text-white',
      toneBackgroundClass
    ]"
  >
    <component :is="toneIcon" class="h-5 w-5 flex-shrink-0" />
    <span>{{ message }}</span>
  </div>
</template>

<script>
import { CheckIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/vue/solid'

const TONES = {
  // A bare check rather than CheckCircleIcon: the confirmation pill is small, and a glyph inside
  // a filled circle reads as a second badge next to the pill itself.
  //
  // Brand rather than a fixed green: every merchant themes this checkout at runtime off
  // --main-brand-hue, so a hardcoded confirmation colour is somebody else's brand on most stores.
  // brand-700 rather than the brand-500 of the button that raised it - the pill carries white text,
  // and at the default hue brand-500 is a mid-lightness orange that white sits on at about 2.5:1.
  // Error keeps its red: that is a warning signal, not a brand surface, and a merchant whose hue is
  // green would otherwise render failures in reassuring green.
  success: { backgroundClass: 'bg-brand-700', icon: 'CheckIcon' },
  error: { backgroundClass: 'bg-red-600', icon: 'XCircleIcon' },
  info: { backgroundClass: 'bg-gray-brand-900', icon: 'InformationCircleIcon' }
}

export default {
  name: 'Toast',
  components: {
    CheckIcon,
    InformationCircleIcon,
    XCircleIcon
  },
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: 'success',
      validator: (value) => Object.keys(TONES).includes(value)
    }
  },
  computed: {
    tone() {
      return TONES[this.type] || TONES.success
    },
    toneBackgroundClass() {
      return this.tone.backgroundClass
    },
    toneIcon() {
      return this.tone.icon
    }
  }
}
</script>
